module.exports = __webpack_public_path__ + "static/media/meteor-dribbble-5.0b192f15.jpg";